module.exports = __webpack_public_path__ + "static/img/step4.048434ec.png";